<template>
    <h2 class="heading">Create {{reportType}} Workflow</h2>
    
    <div class="form">
        <el-form :model="report" label-width="200px" style="width:900px" >
            <el-form-item label="Report type" required>
                {{reportType}}
            </el-form-item>
            <el-form-item label="Report date" required>
                <el-select v-model="reportDate" placeholder="Select report date" style="width:220px;">
                    <el-option v-for="date in reportDates" :key="date" :label="date.name" :value="date.value"/>
                </el-select>
            </el-form-item>
            <el-form-item label="Data files" v-if="reportType=='Leaflet' || reportType=='APxJ'" required>
                <div v-if="dataFiles.indexOf(':') > -1" style="display:block;">
                    <el-tag v-for="item in dataFiles.split(';')" :key="item" @close="removeFile(item)" closable>
                        <a v-if="item.length" href="" @click.prevent="global.down(item.split(':')[1], item.split(':')[0])">{{item.split(':')[0]}}</a>
                    </el-tag>
                </div>
                <el-upload :action="global.upload_path" multiple :on-success="uploaded" 
                    :data="{type:'report', subType:reportType+'/'+reportDate}" :show-file-list="false" >
                    <el-button type="primary" plain>Browse</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item label="Creator remarks">
                <el-input type="textarea" v-model="remarks"/>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="createReport">Create workflow</el-button> &nbsp;  
                <el-button type="default" plain @click="$router.push('/report/reportList?reportType='+reportType)">Cancel</el-button>
                <span v-if="loading" style="display:inline-block; margin-left:20px; vertical-align:middle;">
                    <img src="@/assets/loading.gif" style="height:24px;"/>
                </span>
                <span class="errMsg" v-if="errMsg != ''">{{errMsg}}</span>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { Plus, Minus } from '@element-plus/icons-vue'

export default {
    components: {
        Plus, Minus
    },
    data() {
        return {
            dataFiles: '',
            reportType: null,
            reportDate: null,
            reportDates: [],
            remarks: null,
            errMsg: '',
            loading: false,
            global,
        }
    },
    async created() {
        let result = await AXIOS("/report/getReportDates");
        if (result.success) 
            this.reportDates = result.data;
        this.reportType = this.$route.query.reportType;
        if (this.reportType != 'APxJ')
            this.reportDate = new Date(new Date().getTime()-30*24*3600*1000).toISOString().substring(0, 7);
        else 
            this.reportDate = new Date(new Date().getTime()).toISOString().substring(0, 7);
        
        this.global.index = "report-" + (this.reportType ? this.reportType : "Factsheet");
    },
    computed: {
    },
    async mounted() {
        
    },
    methods: {
        uploaded(response) {
            let files = response.length ? response[0].name + ":" + response[0].url : '';
            if (files != '' && this.dataFiles.indexOf(files) == -1) {
                this.dataFiles = (this.dataFiles == '') ? files : this.dataFiles + ";" + files;
            }
        },
        removeFile(item) {
            this.dataFiles = this.dataFiles + ";"
            this.dataFiles = this.dataFiles.replace(item+";", "");
            if (this.dataFiles.endsWith(";"))
                this.dataFiles = this.dataFiles.substring(0, this.dataFiles.length-1);
        },
        async createReport() {
            if ((this.reportType == 'Leaflet' || this.reportType == 'APxJ') && this.dataFiles == '') {
                this.errMsg = "Please upload data files first";
                return;
            }
            
            this.errMsg = "";
            if (this.loading) return;
            this.loading = true;
            let data = {reportDate: this.reportDate, dataFiles: this.dataFiles, 
                        reportType: this.reportType, remarks: this.remarks};
            let result = await AXIOS("/report/createReport", data);
            if (result.success) {
                this.$router.push("/report/reportList?reportType="+this.reportType);
            }
            this.loading = false;
        }
    }
}
</script>

<style scoped>
    .heading {
        width:800px;
    }
    .errMsg {
        padding-left:10px;
    }
</style>